$(window).on('load', function () {
  $(".loader").delay(1000).addClass('loader-close').fadeOut("slow");
});

$(document).ready(function(){
  $('#app_per_page').keyup(function(event){
    if (event.keyCode === 13) {
      event.preventDefault();
      querySearch('per_page', app_per_page.value);
    }
  });

  // Javascript to enable link to tab
  var url = document.location.toString();
  if (url.match('#')) {
    $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
  }

  if (document.location.toString().match('#')) {
    window.location.hash = ''
  }

  if ($('.contenido').find('.fixed-action-btn').length>=1) {
    $('.contenido').addClass('mb-7');
  }
  
  $('#menuTabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    updateMenu();
  });

  $('.custom-file-input').on('change',function(){
      var fileName = $(this).val().replace('C:\\fakepath\\', " ");
      $(this).next('.custom-file-label').html(fileName);
  });

  $(window).resize(function() {
    topMain();
  });

  topMain();

	$('#menu').metisMenu();
	$('[title]').tooltip();

  $('.deletePruebas').on('click', function(e){
      e.preventDefault();
      var url = $(this).data('url');
      console.log(url);
      $.confirm({
          title: '¿Estás seguro?',
          content: '¡Ya no podrás recuperar esta información!',
          theme: 'supervan', // 'material', 'bootstrap'
          buttons: {
              Confirmar: function () {
                  $('.formDeletePruebas').attr('action', url);
                  $('.formDeletePruebas').submit();
              },
              Cancelar: function () {
              },
          }
      });
  });

  $('.delete-confirm').click(function(e){
    e.preventDefault();

    var url = $(this).data('url');

    $.confirm({
        title: '¿Estás seguro?',
        content: '¡Ya no podrás recuperar esta información!',
        theme: 'supervan', // 'material', 'bootstrap'
        buttons: {
            Confirmar: function () {
                axios.delete(url)
                    .then(response => {
                        location.reload();
                        Vue.toasted.show('Eliminado');
                    })
                    .catch(error => {
                        //modules.$toasted.show('Error al eliminar');
                        Vue.toasted.show('Error al Eliminar');
                        console.log(error.response);
                    });
            },
            Cancelar: function () {
            },
        }
    });
  });

  $('.progress-bar').each(function(){
      var bar_value = $(this).attr('aria-valuenow')+'%';
      var duration = $(this).data('duration') || 150
      
      $(this).animate({width: bar_value}, {
          duration: duration,
          easing: 'easeOutCirc'
      });
  });
  
  $('#menuBTN').click(function() {
      if($('.sidebar-nav').hasClass('sidebar-open')){
        localStorage.setItem('slide', 'false');
      	$('.sidebar-nav').removeClass('sidebar-open');
        $('#menuTabs').removeClass('nav-tabs-full');

     		$('main').removeClass('main-padding-left');
     		$('.sidebar-nav').find('[title]').tooltip('enable');
        var pLeft = 85;
        $('.menu-fixed').css('margin-left', pLeft);
      }else{
        localStorage.setItem('slide', 'true');
      	$('.sidebar-nav').addClass('sidebar-open');
        $('#menuTabs').addClass('nav-tabs-full');

      	$('main').addClass('main-padding-left');
      	$('.sidebar-nav').find('[title]').tooltip('disable');
        var pLeft = 275;
        $('.menu-fixed').css('margin-left', pLeft);
      }
      updateMenu();
  });

  $('#search').next().attr('title', 'Buscar');
  $('[title]').data('placement', 'bottom');
  $('[title]').tooltip();
  
  slide();
  
  $('select[required]').each(function(){
    //2 porque el componente agrega 1 option adicional
    if($(this).children('option').not(':disabled').length == 1) {
      $(this).val($(this).children('option').not(':disabled').val()).trigger('change');
      $(this).parent().addClass("d-none");
    }
  });

  $('select[defaultValue]').each(function(){
    //2 porque el componente agrega 1 option adicional
    if($(this).children('option').not(':disabled').length == 1) {
      $(this).val($(this).children('option').not(':disabled').val()).trigger('change');
      $(this).parent().addClass("d-none");
    }
  });

  /*$("[maxlength]").each(function(){
    $(this).keyup(function() {
      maxLenghtHtml(this);
    });
    maxLenghtHtml(this);
  });*/

  var elementsLength = document.querySelectorAll("[maxlength]:not([noCounter])");
  Array.prototype.forEach.call(elementsLength, function(el, i){
    maxLenghtHtml2(el);
    el.addEventListener("keyup", function(el){maxLenghtHtml2(el.target)});
  });
});

function updateMenu(){
  var parent = $('#app-wrapper').outerHeight();
  var header = 0;
  $('#app-wrapper').find('.wrapper-ignore').each(function(){
    header += $(this).outerHeight() ? $(this).outerHeight() : 0;
  });

  var height = (parent ? parent : 0) - (header ? header : 0);

  $('#app-wrapper').find('.wrapper-content').height(height);
  $('#app-wrapper').find('.wrapper-content').perfectScrollbar('update');
  var container = document.getElementById('menuTabsContent');
  if (container) {
    container.scrollTop = 0;
  }
}

/*function maxLenghtHtml(element){
  var total = $(element).attr('maxLength');
  var caracteres = $(element).val().length || 0;
  var text = caracteres+'/'+total;

  if($(element).next('.counter-lenght').length){
    $(element).next('.counter-lenght').children('small').text(text);
  }else{
    var html = '<div class="counter-lenght float-right"><small>'+text+'</small></div>';
    $(element).after(html);
  }
}*/

function maxLenghtHtml2(element) {
  var total = element.getAttribute('maxlength');
  if (total<=0) {return;}

  if ((" " + element.className + " ").replace(/[\n\t]/g, " ").indexOf(" form-control ") <= -1){  
    return;
  }

  var caracteres = element.value.length || 0;

  if (caracteres > total) {return;}
  var text = caracteres+'/'+total;
  
  var parent2 = element.parentNode;
  if ( (" " + parent2.className + " ").replace(/[\n\t]/g, " ").indexOf(" counter-parent ") > -1 ){  
    parent2.getElementsByClassName('counter')[0].innerHTML = text;
  }else{
    var wrapper = document.createElement('div');
    var counter = document.createElement('small');
    wrapper.className = 'd-flex flex-grow-1 counter-parent';
    counter.className = 'counter';
    counter.innerHTML = text

    parent2.replaceChild(wrapper, element);
    wrapper.appendChild(element);
    wrapper.appendChild(counter);
  }
}

function slide(){
  if (localStorage.getItem('slide') == "true" && window.innerWidth > 576) {
    /*$('.menuBTN').find('.menu-icon').attr('data-icon', 'chevron-left');
    $('#app-container').addClass('app-wrapper');
    $('#menuSide').show("slide");
    $('#menuTabs').addClass('nav-tabs-full');*/
    $('.sidebar-nav').addClass('sidebar-open');
    $('#menuTabs').addClass('nav-tabs-full');

    $('main').addClass('main-padding-left');
    $('.sidebar-nav').find('[title]').tooltip('disable');
    var pLeft = 275;
    $('.menu-fixed').css('margin-left', pLeft);
  }else{
    $('.sidebar-nav').removeClass('sidebar-open');
    $('#menuTabs').removeClass('nav-tabs-full');

    $('main').removeClass('main-padding-left');
    $('.sidebar-nav').find('[title]').tooltip('enable');
    var pLeft = 85;
    $('.menu-fixed').css('margin-left', pLeft);
  }
  updateMenu();
}

function topMain(){
  var hHeader = $('#navbar').outerHeight();
  var pLeft = $('main').css('padding-left');
  var pRight = $('main').css('padding-right');
  var MenuHeader = $('.menu-fixed').outerHeight();
  
  $('main').css('padding-top', hHeader);
  $('.menu-fixed').css('margin-left', pLeft);
  $('.menu-fixed').css('margin-right', pRight);
  $('.fixed-body').css('margin-top', MenuHeader+5);
}

$('#carouselExample').on('slide.bs.carousel', function (e) {
    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 7;
    var totalItems = $('.carousel-item').length;
    
    if (idx >= totalItems-(itemsPerSlide-1)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction=="left") {
                $('.carousel-item').eq(i).appendTo('.carousel-inner');
            }
            else {
                $('.carousel-item').eq(0).appendTo('.carousel-inner');
            }
        }
    }
});

function querySearch(key, value, url=''){
    if (url=='') {
        url = document.location.href
    }
    var indexKey = url.indexOf(key)
    if (indexKey>-1) {
        var len = url.length
        var temp = url.substring(indexKey, len)
        var query = ''
        if (temp.indexOf('&')>-1) {
            query = temp.substring(0, temp.indexOf('&'))
        }else{
            query = temp
        }   
        var queryValue = `${key}=${value}`
        url = url.replace(query, queryValue)
    }else{
        if (value) {
            if (document.location.href.indexOf("?")>-1) {
                url = document.location.href + '&'+key+'='+value
            }else{
                url = document.location.href + '?'+key+'='+value
            }
        }else{
            url = document.location.href
        }
    }

    pageindexKey = url.indexOf('page')
    if (pageindexKey>-1) {
      var cont = url.split('?')
      if(cont.length>1){
        var params = cont[1].split('&')
        var pagequery = params.filter(x => x.includes('page'))[0] ?? ''
        
        var pagequeryValue = `${'page'}=1`
        url = url.replace(pagequery, pagequeryValue)
      }
    }
    window.location.replace(url)
}

$(document).ready(function() {
  /* show lightbox when clicking a thumbnail */
  $('a.thumb').click(function(event){
    event.preventDefault();
    var content = $('.modal-body');
    content.empty();
      var title = $(this).attr("title");
      $('.modal-title').html(title);        
      content.html($(this).html());
      $(".modal-profile").modal({show:true});
  });
});